var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForgotEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 667.96 418.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e0e0e0;}.cls-2{fill:#ebebeb;}.cls-3{fill:#f5f5f5;}.cls-4{fill:#3969d5;}.cls-5{fill:#263238;}.cls-6{fill:#455a64;}.cls-7{fill:#fafafa;}.cls-8{opacity:0.3;}.cls-9{opacity:0.5;}.cls-10{fill:#ffbe9d;}.cls-11{opacity:0.2;}.cls-12{opacity:0.6;}.cls-13{fill:#fff;}.cls-14{fill:#eb996e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.31,398.6A55.09,55.09,0,0,0,223.47,371c-11.88-5.56-38.37-3-38.37-3l-69.62-.14c1.43,6.11,6,21.82,9.35,27.1s8.4,9.74,14.44,11.45c7.39,2.09,15.22-.07,22.89-.57,13.49-.87,26.69,3.49,39.68,7.23s26.78,6.94,39.92,3.76c3.73-.91,7.64-2.57,9.45-6C253.22,407.16,252,402.51,250.31,398.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.54,151.79s-7.92-.57-7.19,17.2,2.54,27.22,2.54,27.22-.23,3.94-3.28,3.17-8.79-4.61-11.62-1.74-1.9,7.53,2,12.9S31,228,31.73,229.08s1,3.09-1.16,2.89-16.76-5.14-18.69,1.93,11.38,20.24,12.81,21.7,1.51,2.4.93,3.29-5.33-1.24-9.54-2.48S6.77,254.48,6,258.65s5.09,16.37,27.06,29.2l10.57,5.28,10-6.38c20.57-15,25.19-27.69,24-31.76s-6.19-2.87-10.25-1.22-8.58,4.24-9.24,3.41-.68-1.75.59-3.36S72,237.78,69.32,231s-16.66-.46-18.79,0-2.05-1.63-1.44-2.77,7.47-14,10.82-19.72,3.92-10.37.7-13-8.43,1.82-11.39,2.89-3.58-2.82-3.58-2.82.85-9.59-.2-27.34-9.06-16.32-9.06-16.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.17,167.7s0,.13,0,.37,0,.63.08,1.09c.07,1,.16,2.39.29,4.2.24,3.64.55,8.92.91,15.44.73,13,1.57,31,2.44,50.95s1.67,37.93,2.32,51c.33,6.51.6,11.78.79,15.44.09,1.81.16,3.22.21,4.2,0,.47,0,.83,0,1.09a3.64,3.64,0,0,1,0,.38s0-.13,0-.38,0-.62-.08-1.09c-.07-1-.17-2.38-.29-4.19-.24-3.64-.55-8.92-.91-15.44-.73-13-1.57-31.05-2.44-51s-1.67-37.92-2.32-51c-.34-6.51-.6-11.78-.79-15.44-.09-1.81-.16-3.22-.21-4.2,0-.47,0-.83,0-1.09A3.64,3.64,0,0,1,37.17,167.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.8,203.32a3.59,3.59,0,0,1,.65.55c.41.37,1,.92,1.68,1.61,1.4,1.38,3.27,3.34,5.3,5.54l5.17,5.66,1.57,1.7a3.28,3.28,0,0,1,.55.66,4,4,0,0,1-.66-.54c-.4-.37-1-.93-1.67-1.62-1.38-1.4-3.23-3.38-5.26-5.58l-5.2-5.62L25.34,204A3.08,3.08,0,0,1,24.8,203.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.77,218.69c-.08-.08,3.79-4.13,8.63-9s8.85-8.84,8.93-8.76-3.79,4.13-8.64,9S40.85,218.77,40.77,218.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.73,249.32a3.49,3.49,0,0,1,.74-.47l2.06-1.16c1.75-1,4.15-2.34,6.75-3.94s4.91-3.12,6.57-4.23l2-1.31a3.53,3.53,0,0,1,.75-.45,3.8,3.8,0,0,1-.66.57c-.44.35-1.09.84-1.9,1.43-1.63,1.17-3.92,2.74-6.53,4.33s-5,2.93-6.82,3.85c-.89.46-1.62.82-2.13,1.05A4.6,4.6,0,0,1,40.73,249.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.22,238.6a3,3,0,0,1,.73.34L25.87,240c1.61.91,3.81,2.2,6.24,3.64s4.61,2.77,6.19,3.75l1.85,1.17a3.82,3.82,0,0,1,.65.48,2.81,2.81,0,0,1-.74-.34c-.45-.25-1.11-.61-1.91-1.07-1.61-.91-3.82-2.2-6.25-3.64s-4.61-2.77-6.18-3.75l-1.85-1.17A3.82,3.82,0,0,1,23.22,238.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.75,265.63a6.15,6.15,0,0,1,.93.45l2.46,1.36c2.06,1.16,4.91,2.79,8,4.61s5.95,3.49,8,4.71l2.4,1.47a5.6,5.6,0,0,1,.85.58,4.35,4.35,0,0,1-.93-.45L39,277c-2.07-1.16-4.91-2.79-8-4.61s-5.95-3.49-8-4.71l-2.39-1.47A4.61,4.61,0,0,1,19.75,265.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,278.35a4.51,4.51,0,0,1,.92-.62l2.57-1.56c2.16-1.32,5.15-3.16,8.4-5.28s6.13-4.09,8.22-5.55l2.47-1.71a5,5,0,0,1,.93-.59,6.11,6.11,0,0,1-.84.72c-.56.44-1.37,1.06-2.4,1.82-2,1.51-4.91,3.54-8.16,5.65s-6.27,3.92-8.48,5.18c-1.11.63-2,1.13-2.64,1.46A6.39,6.39,0,0,1,42,278.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.83 296.59 28.59 296.59 38.14 368.83 48.29 368.83 57.83 296.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.11,305.47s0,.1.16.25a1.73,1.73,0,0,0,.7.51,3.57,3.57,0,0,0,3.09-.38c1.18-.65,2.21-1.93,3.79-2.5a8.29,8.29,0,0,1,5.38.11,22.77,22.77,0,0,1,5,2.43,34.89,34.89,0,0,0,4.08,2.18,11.47,11.47,0,0,0,3,.87,6.24,6.24,0,0,0,.85.06c.19,0,.29,0,.29,0a15,15,0,0,1-4-1.21,39.76,39.76,0,0,1-4-2.25A22.36,22.36,0,0,0,43.37,303a8.65,8.65,0,0,0-5.68-.06,7.62,7.62,0,0,0-2.13,1.32,15.66,15.66,0,0,1-1.68,1.3,3.4,3.4,0,0,1-2.84.49A2.88,2.88,0,0,1,30.11,305.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.18,318.77s.23-.3.69-.77a6.32,6.32,0,0,1,2.33-1.48,10.26,10.26,0,0,1,4.07-.62,43,43,0,0,1,5.08.7,17.48,17.48,0,0,0,5.21.21,13.85,13.85,0,0,0,4.1-1.17,13.22,13.22,0,0,0,2.47-1.46,3.24,3.24,0,0,0,.78-.71,25.23,25.23,0,0,1-3.38,1.86,14.87,14.87,0,0,1-4,1.05,18.12,18.12,0,0,1-5.08-.25,38.33,38.33,0,0,0-5.15-.67,10.43,10.43,0,0,0-4.21.74,6,6,0,0,0-2.34,1.67,3.7,3.7,0,0,0-.44.65C31.2,318.68,31.16,318.76,31.18,318.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.52,325.89a2.55,2.55,0,0,0-.81-.41,8.25,8.25,0,0,0-2.42-.52,14.84,14.84,0,0,0-3.66.21c-1.37.22-2.83.59-4.36.92a18.61,18.61,0,0,1-4.36.49,9.46,9.46,0,0,1-3.45-.75,7.77,7.77,0,0,1-2.63-1.95,2.4,2.4,0,0,0,.5.77,6.09,6.09,0,0,0,2,1.49,9.23,9.23,0,0,0,3.58.88,17.65,17.65,0,0,0,4.47-.46c1.56-.33,3-.72,4.34-1a16.94,16.94,0,0,1,3.57-.31A13.81,13.81,0,0,1,54.52,325.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.76,335.91a4.74,4.74,0,0,1,2.84-.28,14,14,0,0,1,3,1.1,11.15,11.15,0,0,0,3.85,1.07,11.61,11.61,0,0,0,7-1.62,10.31,10.31,0,0,0,1.74-1.34c.36-.38.54-.6.51-.62a25.14,25.14,0,0,1-2.42,1.66,11.92,11.92,0,0,1-6.78,1.44c-2.77-.16-4.9-1.81-6.82-2a4.31,4.31,0,0,0-2.2.19A1.51,1.51,0,0,0,33.76,335.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.39,349.78a5.7,5.7,0,0,0,2.44-.48c1.47-.5,3.29-1.62,5.41-2.47a9.12,9.12,0,0,1,3.11-.65,5.8,5.8,0,0,1,2.5.57,5.45,5.45,0,0,1,1.8,1.56,1.31,1.31,0,0,0-.28-.61A3.85,3.85,0,0,0,49,346.46a5.59,5.59,0,0,0-2.65-.72,8.78,8.78,0,0,0-3.28.65c-2.2.88-4,2-5.37,2.59S35.38,349.7,35.39,349.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.82,356.23a7.06,7.06,0,0,0,1.85.6,33.65,33.65,0,0,0,4.63.78,32.89,32.89,0,0,0,4.69.14,7.16,7.16,0,0,0,1.94-.23c0-.15-3,0-6.58-.38S36.86,356.09,36.82,356.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 498.53,
    y: 183.88,
    width: 91.21,
    height: 61.48,
    transform: "translate(-34.14 126.62) rotate(-12.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M582.2,175.15a7.12,7.12,0,0,1-.65,1l-2,2.74-7.41,10c-6.37,8.45-15.09,20-24.76,32.81l-.2.27-.31-.15-.73-.36-37.47-18.19-11.32-5.6-3.05-1.56a7.17,7.17,0,0,1-1.05-.59,6.13,6.13,0,0,1,1.12.44l3.12,1.42,11.43,5.36,37.57,18,.74.35-.51.13,25-32.66c3.17-4.09,5.76-7.43,7.62-9.81l2.1-2.65A5.85,5.85,0,0,1,582.2,175.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507,255.4c-.2-.1,4.61-9.84,10.74-21.76s11.28-21.49,11.48-21.38-4.61,9.85-10.74,21.76S507.17,255.51,507,255.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M558.58,204.75c.14-.17,8.61,6.47,18.92,14.85s18.54,15.31,18.39,15.48-8.61-6.46-18.92-14.84S558.43,204.93,558.58,204.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 189.65,
    y: 8.38,
    width: 36.25,
    height: 53.78,
    transform: "translate(126.65 229.78) rotate(-77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.12,24.13a4.82,4.82,0,0,1-.6.35l-1.75.94-6.5,3.39-21.57,11-.18.09-.13-.16-.3-.37L191.9,20.1l-4.56-5.88-1.22-1.61a3.42,3.42,0,0,1-.4-.59,3.54,3.54,0,0,1,.47.53l1.3,1.55,4.68,5.79,15.31,19.2.3.38-.3-.06L229.12,28.5l6.56-3.24,1.8-.86A2.6,2.6,0,0,1,238.12,24.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.56,47.34c-.08-.1,5-4,11.3-8.78s11.51-8.49,11.59-8.39-5,4-11.3,8.78S177.64,47.45,177.56,47.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218,33.75c.12,0,2.91,5.65,6.22,12.75s5.89,12.89,5.77,13-2.9-5.65-6.21-12.75S217.85,33.81,218,33.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 483.37,
    y: 27.46,
    width: 41.67,
    height: 28.09,
    transform: "translate(24.58 202.44) rotate(-23.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M518.06,20.63a2.75,2.75,0,0,1-.21.5c-.17.35-.39.81-.66,1.39-.61,1.24-1.47,3-2.51,5.09l-8.43,16.78-.07.14-.15,0-.36-.1L487.34,39.3l-5.55-1.58-1.5-.45-.52-.18a2.13,2.13,0,0,1,.54.1l1.52.39L487.41,39l18.36,5,.36.1-.21.09,8.52-16.72c1.09-2.11,2-3.82,2.62-5l.72-1.36A3.64,3.64,0,0,1,518.06,20.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M490.86,62.89c-.1,0,1.26-4.8,3-10.66s3.3-10.59,3.4-10.55-1.26,4.8-3,10.66S491,62.92,490.86,62.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M509.88,35.88c.05-.09,4.41,2.2,9.73,5.12s9.59,5.35,9.54,5.44-4.4-2.2-9.72-5.11S509.83,36,509.88,35.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M568.5,281.44A31.64,31.64,0,0,0,555,276.78c-2.21-.23-4.63-.16-6.41,1.18a1.33,1.33,0,0,0-.66,1.17,1.5,1.5,0,0,0,.63.8,19.39,19.39,0,0,0,20,1.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M568.15,281.06a66.07,66.07,0,0,1-8.75-7.7,22,22,0,0,1-5.48-10.14,4.09,4.09,0,0,1,.43-3.4c7,5.45,12.45,12.49,13.8,21.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M568.43,281.39a31.46,31.46,0,0,1,.16-11.49,15.57,15.57,0,0,1,6.12-9.48c1.2,2.82.69,6.07-.16,9a43.6,43.6,0,0,1-6.07,12.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M575.27,293.64c-4.16.51-7.77,2.69-10.87,5.5a20.54,20.54,0,0,0-6.21,10.67c4.07-.25,7.52-3.12,10-6.34s4.24-6.75,7-9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M576.75,295.6a26.83,26.83,0,0,1,3.09-25.35c2.37,8.42,1.5,17.92-3.09,25.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M585.78,306.36A19.36,19.36,0,0,0,567.26,317c-.23.46-.43,1.05-.13,1.46a1.4,1.4,0,0,0,1.23.36c3.65-.24,6.89-2.44,9.56-4.94s5-5.39,8-7.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M585.5,305.77a34.42,34.42,0,0,1-.35-19.27c.68-2.48,1.82-5.1,4.11-6.26a.64.64,0,0,1,1,.35,11.5,11.5,0,0,1,1,5.53,34.3,34.3,0,0,1-.86,5.6c-.73,3.42-1.11,7.1-3,10a20.42,20.42,0,0,0-1.19,2.21c-.36.75-.36,1-.68,1.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M609.41,309.34c-1.77-6.74.11-14.91,4.36-20.44.31-.41.72-.84,1.23-.79.79.07,1,1.11,1,1.9a36.88,36.88,0,0,1-6.54,19.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M611.57,310.81a29.73,29.73,0,0,0,24.39-5,19.73,19.73,0,0,0-13.21-1.62c-4.41,1-8.44,3-11.18,6.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M613.38,306.32c4.59-7.47,13.38-12.35,22.14-12.8-1,3.56-3.94,6.33-7.24,8a40,40,0,0,1-10.63,3.1c-1.41.28-3.35.58-4.27,1.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M609.87,284.55a64.48,64.48,0,0,0,2.83-13,21.54,21.54,0,0,0-2.59-12.82c-4.28,8.29-4.71,18-.37,26.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M624.29,277.26c5-9.1,15.23-16.38,25.57-17.4-4,9.94-14.87,17.61-25.57,17.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M621.13,279c7.48,1.14,13.84,5.91,20.82,8.8a9.33,9.33,0,0,0,4.71.91,3.68,3.68,0,0,0,2.3-6.52,10,10,0,0,0-3.41-2.07c-7.61-3.17-15.76-3.25-23.77-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M616.81,284.28c1.69.49,2.27,1.36,3.61,2.5a38.88,38.88,0,0,0,15.79,8.11c.6.15,1.39.21,1.69-.33s-.07-1.05-.41-1.48a21.76,21.76,0,0,0-9.53-6.47c-3.64-1.36-6.8-3-11.15-2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M611.93,252.64a29.88,29.88,0,0,0,22.91,7.79,1.65,1.65,0,0,0,1-.37c.58-.63-.12-1.6-.79-2.12-6.73-5.25-14.89-7.43-23.16-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M617.72,250.52a31.9,31.9,0,0,1,28.58-4.71,22.72,22.72,0,0,1-13.62,6,42.9,42.9,0,0,1-15-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M615.42,236c-.66-6.72-.23-12-.7-18.78,0-.54-.15-1.19-.66-1.38-.7-.27-1.29.59-1.52,1.31a21.54,21.54,0,0,0,2.87,18.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M614.94,236.72a39.53,39.53,0,0,0,11.13-10.82c2.2-3,4-6.61,3.55-10.31a10.68,10.68,0,0,0-8,4,22.37,22.37,0,0,0-4.09,8.24c-.89,3-1.52,6-2.56,8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M625.87,233.68a89.52,89.52,0,0,0,27.4-16.15c-3.27-1.32-7-.53-10.29.79a32.46,32.46,0,0,0-17.25,15.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M618,240.4a55.75,55.75,0,0,0,15.21.07c4.94-.82,9.6-2.78,14.21-4.72a1.63,1.63,0,0,0,1-.73,1.11,1.11,0,0,0-.34-1.21,2.88,2.88,0,0,0-1.21-.57c-5-1.4-10.42-.75-15.35.91A71.39,71.39,0,0,0,618,240.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M589.13,252.87c-3.45-7-3.23-15.1-.25-22.28,2.1,3.2,2.36,7.27,2,11.08s-1.55,7.72-1.62,11.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M575.34,245.91a31.08,31.08,0,0,0-23.08,9.84,21.62,21.62,0,0,0,12.64-2.35,63.57,63.57,0,0,0,10.83-7.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M566.08,242.81c-4.22-.34-8.27-.86-12.33.38a14.76,14.76,0,0,0-9.39,8A22.37,22.37,0,0,0,555.91,249a66.41,66.41,0,0,0,10.17-6.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M579.8,243c-3.79-2.49-7.69-5-12.1-6.05s-9.53-.27-12.61,3.06c3.57,2.1,7.91,2.35,12,2.34s9.23-.05,13.13,1.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M579.82,243.16c-6.48-6.37-8.94-17.8-6.33-26.51a40.42,40.42,0,0,1,6.33,26.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M597.65,225.12c1.22-2.84,2.08-5.82,3.17-8.72a25.1,25.1,0,0,1,4.54-8,11.91,11.91,0,0,1,8-4.16,32.39,32.39,0,0,1-15.59,21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M594.42,228.88c-2-2.79-4.36-6.56-7.1-8.64s-6.32-3.34-9.67-2.54a22.5,22.5,0,0,0,16.77,11.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M595.07,225.35a47.5,47.5,0,0,1-3.2-10.35,16.14,16.14,0,0,1,1.62-10.53c3.56,6.72,4.7,13.94,1.76,21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M597.68,204.47c2-6.67,8.12-11.58,14.71-13.83a5.47,5.47,0,0,1,2.58-.39,2.23,2.23,0,0,1,1.9,1.59c.24,1.13-.69,2.15-1.58,2.9a50.09,50.09,0,0,1-17.61,9.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M597.75,199c.26-4.3.53-8.66,1.92-12.73s4.1-7.89,8-9.68c.67,4.34-1.25,8.66-3.56,12.4s-5.1,7.26-6.48,11.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M597.65,202c-1.67-4.86-1.84-11-4.75-15.26-2-3-5.29-5-7-8.11a12.38,12.38,0,0,0,.41,9.2,26.55,26.55,0,0,0,5.39,7.71c2.15,2.3,4,4,6,6.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M597.68,345.08c-.13,0-.24-32.42-.25-72.4s.09-72.4.22-72.4.24,32.41.25,72.4S597.81,345.08,597.68,345.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M626,248a7.13,7.13,0,0,1-1.22.45l-3.36,1.13c-2.82,1-6.71,2.36-10.93,4.09s-8.11,3.25-10.35,5.19a7.69,7.69,0,0,0-2.08,2.75c-.32.76-.38,1.23-.42,1.22s0-.12,0-.34a5,5,0,0,1,.24-.94,7.34,7.34,0,0,1,2-2.94,18.1,18.1,0,0,1,4.49-2.79c1.8-.84,3.79-1.71,5.91-2.58,4.23-1.74,8.14-3.09,11-4,1.43-.45,2.6-.77,3.41-1A6,6,0,0,1,626,248Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M635.29,225.17a2,2,0,0,1-.34.36l-1,1L630,230c-3.36,3-7.9,7-12.93,11.51s-9.4,8.78-12.42,12c-1.52,1.61-2.71,2.95-3.52,3.88l-.94,1.07a2.07,2.07,0,0,1-.35.36s.08-.15.28-.41.48-.65.87-1.13c.77-1,1.93-2.35,3.41-4a166.89,166.89,0,0,1,12.36-12.13c5.06-4.49,9.67-8.51,13-11.41l4-3.42,1.1-.91A2.15,2.15,0,0,1,635.29,225.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M611.66,246.11c-.14-.06.92-2.49,2-5.57s1.56-5.67,1.69-5.65a19.23,19.23,0,0,1-1.25,5.8,37.55,37.55,0,0,1-1.57,3.9A6.36,6.36,0,0,1,611.66,246.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M597.71,265.73a5.53,5.53,0,0,1-.78-.9l-2-2.55c-1.67-2.17-4-5.15-6.58-8.42s-5-6.2-6.7-8.32c-.82-1-1.5-1.85-2-2.52a6.1,6.1,0,0,1-.7-1,6.19,6.19,0,0,1,.84.85c.52.56,1.25,1.39,2.15,2.42,1.79,2.07,4.22,5,6.82,8.24s4.87,6.29,6.47,8.51c.81,1.11,1.45,2,1.88,2.64A6.78,6.78,0,0,1,597.71,265.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M591.5,257.76a11.42,11.42,0,0,1-2.61-4.87,14.14,14.14,0,0,1-.59-4.91h.21c-.09.38-.16.58-.2.57a1.37,1.37,0,0,1,0-.6l.2,0a22.77,22.77,0,0,0,.83,4.77A35.26,35.26,0,0,0,591.5,257.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M583.48,247.67a8.55,8.55,0,0,0-1.82-1,12.13,12.13,0,0,0-5-.41,31.9,31.9,0,0,0-5.08.82,17.85,17.85,0,0,1-2.09.51,6.91,6.91,0,0,1,2-.82,22.64,22.64,0,0,1,5.13-1,10.92,10.92,0,0,1,5.2.56A3.22,3.22,0,0,1,583.48,247.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M581.58,245.23c0,.07-1.06-.43-2.79-1a28,28,0,0,0-14-1.07c-1.8.32-2.88.66-2.91.58a2.59,2.59,0,0,1,.74-.31,16.5,16.5,0,0,1,2.1-.59,24.87,24.87,0,0,1,14.21,1.08,17.63,17.63,0,0,1,2,.9A2.78,2.78,0,0,1,581.58,245.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M597.65,234.89a55.93,55.93,0,0,1-2-7,56.42,56.42,0,0,1-1.58-7.17,58,58,0,0,1,2,7.05A58.59,58.59,0,0,1,597.65,234.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M597.78,234.89a34.07,34.07,0,0,0-2.25-4.22,18.47,18.47,0,0,0-3.32-3.42,3,3,0,0,1,1.28.66,10.29,10.29,0,0,1,2.42,2.49A9.45,9.45,0,0,1,597.78,234.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M597.68,327.8s-.15-.78-.51-2.16A30.67,30.67,0,0,0,595,320a77.45,77.45,0,0,0-11.49-16.19c-2.57-2.93-5.06-5.7-7.17-8.35a57.9,57.9,0,0,1-5.13-7.39,36.56,36.56,0,0,1-2.59-5.49c-.23-.67-.41-1.2-.5-1.57a2.72,2.72,0,0,1-.14-.56s.28.75.82,2.07a39.8,39.8,0,0,0,2.7,5.38,62.3,62.3,0,0,0,5.17,7.29c2.13,2.62,4.62,5.37,7.19,8.31,5.19,5.83,9.26,11.71,11.44,16.36a27.74,27.74,0,0,1,2,5.71,14.39,14.39,0,0,1,.29,1.63A3,3,0,0,1,597.68,327.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M623.28,298.89a14.86,14.86,0,0,1-1.34.75,28.49,28.49,0,0,0-3.48,2.3,39.35,39.35,0,0,0-4.57,4.17c-1.61,1.69-3.26,3.66-4.95,5.77-3.37,4.23-6.52,8-8.41,11a41.58,41.58,0,0,0-2.11,3.61,12,12,0,0,1-.74,1.35s0-.14.12-.38.24-.6.45-1.05a34.54,34.54,0,0,1,2-3.71,118.91,118.91,0,0,1,8.33-11.07c1.69-2.12,3.36-4.09,5-5.78a37.43,37.43,0,0,1,4.69-4.14,23.83,23.83,0,0,1,3.59-2.19c.45-.23.81-.36,1-.47S623.27,298.87,623.28,298.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M623.78,308.27a21,21,0,0,1-2.84.41,37.39,37.39,0,0,0-6.72,1.32,20.31,20.31,0,0,0-6,3.16c-1.39,1.08-2.05,2-2.11,1.91a2,2,0,0,1,.42-.65,10.08,10.08,0,0,1,1.48-1.51,18.16,18.16,0,0,1,6.08-3.35,30,30,0,0,1,6.84-1.21A15.4,15.4,0,0,1,623.78,308.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M606.92,314c-.15-.08,1.13-2,2.12-4.66s1.15-5,1.31-4.95a4.54,4.54,0,0,1,0,1.52,17,17,0,0,1-.83,3.59,17.85,17.85,0,0,1-1.65,3.29A4.57,4.57,0,0,1,606.92,314Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M631.57,273.7a1.88,1.88,0,0,1-.46.24l-1.33.61c-.58.25-1.29.57-2.09,1S626,276.38,625,277l-1.55.88c-.53.31-1.06.68-1.63,1-1.14.69-2.28,1.54-3.5,2.41a60.14,60.14,0,0,0-13.49,14c-.83,1.25-1.64,2.42-2.29,3.59-.33.57-.68,1.11-1,1.66l-.83,1.58c-.55,1-.94,1.94-1.33,2.75s-.69,1.53-.92,2.13l-.56,1.35a2.19,2.19,0,0,1-.22.46,1.75,1.75,0,0,1,.14-.49c.12-.37.28-.83.47-1.39s.48-1.33.85-2.16.74-1.79,1.28-2.8c.25-.51.52-1.05.8-1.6s.63-1.11.95-1.69c.65-1.18,1.45-2.37,2.28-3.63A57.65,57.65,0,0,1,618,280.94c1.24-.87,2.4-1.72,3.56-2.4.57-.35,1.11-.71,1.65-1l1.57-.86c1-.57,1.94-1,2.76-1.37s1.53-.69,2.13-.92l1.37-.52A2.26,2.26,0,0,1,631.57,273.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M611.31,287.28a3.21,3.21,0,0,1,1.11-1.66,7,7,0,0,1,4.49-1.72,12.18,12.18,0,0,1,4.72.92,6.52,6.52,0,0,1,1.79.87,10.94,10.94,0,0,1-1.89-.56,14.65,14.65,0,0,0-4.6-.77,7.34,7.34,0,0,0-4.29,1.51A12,12,0,0,0,611.31,287.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M608.28,290.4a12,12,0,0,0,1-8.47,2.75,2.75,0,0,1,.53,1.2,8.65,8.65,0,0,1,.22,3.18,8.45,8.45,0,0,1-.95,3C608.67,290.06,608.33,290.43,608.28,290.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M575.29,332.44c.7,12.39,4.43,25,10.17,37.73h25c5.48-12.61,9-25.19,9.57-37.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M616,352.49c0,.13-8.23.24-18.37.24s-18.36-.11-18.36-.24,8.22-.23,18.36-.23S616,352.36,616,352.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M615.4,357c0,.13-7.71.23-17.22.23S581,357.11,581,357s7.71-.23,17.21-.23S615.4,356.85,615.4,357Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 134.87,
    y: 109.99,
    width: 384.52,
    height: 254.28,
    rx: 14.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.84,347.84H536.44a0,0,0,0,1,0,0v4.45a17.8,17.8,0,0,1-17.8,17.8h-381a17.8,17.8,0,0,1-17.8-17.8v-4.45a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 145.19,
    y: 120.09,
    width: 362.8,
    height: 214.73
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "289.23 345.46 294.39 353.68 367.14 353.68 371.94 345.46 289.23 345.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 152.67,
    y: 127.36,
    width: 348.6,
    height: 206.78,
    rx: 3.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "500.89 334.44 152.29 334.44 152.67 142.81 500.89 142.81 500.89 334.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M181.26,135.35a2.79,2.79,0,1,1-2.79-2.79A2.79,2.79,0,0,1,181.26,135.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M164.38,135.35a2.79,2.79,0,1,1-2.78-2.79A2.78,2.78,0,0,1,164.38,135.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M172.48,135.35a2.79,2.79,0,1,1-2.78-2.79A2.78,2.78,0,0,1,172.48,135.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M516.08,345.46c0,.14-85.34.25-190.59.25s-190.62-.11-190.62-.25,85.33-.25,190.62-.25S516.08,345.32,516.08,345.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "264.29 217.67 406.12 216.35 410.27 312.76 263.41 311.71 264.29 217.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.29,217.67l67-54.45a7.71,7.71,0,0,1,9.74,0l65.08,53.12"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.29,217.67l67-54.45a7.71,7.71,0,0,1,9.74,0l65.08,53.12"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M263.41,311.71c-.17-.17,11.15-12.59,25.3-27.74s25.77-27.31,26-27.14-11.15,12.58-25.31,27.74S263.59,311.87,263.41,311.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M410.27,312.76c-.18.16-11.26-12-24.75-27.07s-24.28-27.5-24.1-27.67,11.26,12,24.76,27.08S410.45,312.6,410.27,312.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "406.12 216.35 335.02 273.39 264.29 217.67"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "271.45 222.93 271.13 178.63 395.32 176.9 396.81 223.51 335.01 272.64 271.45 222.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M271.45,222.92l1.18.89,3.38,2.61,12.86,10,46.27,36.07h-.26l61.77-49.18-.09.21c-.29-8.89-.59-18.21-.89-27.71-.21-6.38-.41-12.7-.61-18.89l.26.25L271.14,178.8l.16-.17c.06,13.93.12,25,.15,32.58,0,3.79,0,6.71,0,8.7,0,1,0,1.73,0,2.25s0,.76,0,.76,0-.24,0-.74,0-1.26,0-2.23c0-2-.06-4.9-.1-8.68-.07-7.61-.18-18.69-.31-32.64v-.17h.16l124.18-1.82h.26v.25c.2,6.19.4,12.51.61,18.9.3,9.49.6,18.82.88,27.71v.13l-.1.08-61.84,49.1-.13.1-.13-.1-46.22-36.27L275.9,226.48l-3.33-2.64C271.82,223.24,271.45,222.92,271.45,222.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375.74,199.25c0,.14-19,.41-42.41.6s-42.43.23-42.43.09,19-.42,42.42-.61S375.74,199.1,375.74,199.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375.76,211.76c0,.14-19,.41-42.41.6s-42.42.23-42.42.09,19-.42,42.42-.61S375.76,211.61,375.76,211.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375.79,226.18c0,.14-19,.41-42.41.61S291,227,291,226.87s19-.41,42.42-.61S375.79,226,375.79,226.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375.82,240.6c0,.14-18.11.41-40.46.59s-40.47.21-40.47.07,18.11-.41,40.47-.59S375.82,240.46,375.82,240.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M360,253.29a1.65,1.65,0,0,1-.5.06l-1.43.06-5.24.13-17.31.31c-6.76.13-12.89.17-17.32.17l-5.24,0-1.43,0a2,2,0,0,1-.5,0,1.65,1.65,0,0,1,.5-.06l1.42-.06,5.25-.13,17.31-.32c6.76-.12,12.88-.16,17.31-.16l5.25,0,1.43,0A2,2,0,0,1,360,253.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M344,265.49a76.73,76.73,0,0,1-9,.28,80.12,80.12,0,0,1-9-.24,79.42,79.42,0,0,1,9-.28A80.12,80.12,0,0,1,344,265.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M668,369.24c0,.14-149.54.26-334,.26s-334-.12-334-.26S149.51,369,334,369,668,369.1,668,369.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Envelope_3",
    "data-name": "Envelope 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M360.74,176.51c.14,0,.2.59.13,1.27s-.23,1.24-.38,1.22-.2-.58-.13-1.27S360.59,176.5,360.74,176.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M362.07,166.77a11.62,11.62,0,0,1-.74,4.86,11.62,11.62,0,0,1,.74-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M364,157.14a6,6,0,0,1-.27,2.46,6.14,6.14,0,0,1-.79,2.34,11.88,11.88,0,0,1,1.06-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M366.7,147.68a6.24,6.24,0,0,1-.46,2.43,6.08,6.08,0,0,1-1,2.27,6.17,6.17,0,0,1,.47-2.43A5.79,5.79,0,0,1,366.7,147.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M370.13,138.47a6.19,6.19,0,0,1-.67,2.38,6,6,0,0,1-1.15,2.18,6.23,6.23,0,0,1,.67-2.38A5.92,5.92,0,0,1,370.13,138.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M374.39,129.62a11.85,11.85,0,0,1-2.24,4.37,6.09,6.09,0,0,1,.89-2.31C373.66,130.47,374.26,129.55,374.39,129.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M379.53,121.24a6,6,0,0,1-1.15,2.18c-.72,1.15-1.41,2-1.53,1.94a5.81,5.81,0,0,1,1.09-2.22C378.7,122,379.41,121.16,379.53,121.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M385.59,113.5a6.34,6.34,0,0,1-1.37,2.06c-.87,1-1.66,1.81-1.78,1.72s.5-1,1.38-2.06S385.48,113.4,385.59,113.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M392.51,106.53c.1.11-.62,1-1.6,1.88s-1.86,1.6-2,1.5.61-.94,1.6-1.88S392.42,106.42,392.51,106.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M400.25,100.47c.08.12-.74.86-1.83,1.66a6.19,6.19,0,0,1-2.13,1.25c-.09-.12.73-.86,1.83-1.67A6,6,0,0,1,400.25,100.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M408.73,95.49a11.92,11.92,0,0,1-4.33,2.35c-.07-.13.84-.76,2-1.4A6,6,0,0,1,408.73,95.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M417.83,91.79a6,6,0,0,1-2.22,1.09,6.13,6.13,0,0,1-2.4.59,5.92,5.92,0,0,1,2.22-1.08A6.08,6.08,0,0,1,417.83,91.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M427.39,89.57a6.2,6.2,0,0,1-2.37.66,6,6,0,0,1-2.45.25,6,6,0,0,1,2.35-.76A5.58,5.58,0,0,1,427.39,89.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M437.2,89a5.79,5.79,0,0,1-2.45.29,6.09,6.09,0,0,1-2.46-.23A11.72,11.72,0,0,1,437.2,89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M447,90.17a6.17,6.17,0,0,1-2.47-.13,6.34,6.34,0,0,1-2.39-.65,6.05,6.05,0,0,1,2.47.14A6,6,0,0,1,447,90.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M456.37,93a5.84,5.84,0,0,1-2.41-.56,6.22,6.22,0,0,1-2.24-1,5.9,5.9,0,0,1,2.41.56A6.16,6.16,0,0,1,456.37,93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M465.12,97.44a6,6,0,0,1-2.26-1c-1.18-.67-2.07-1.31-2-1.44a5.84,5.84,0,0,1,2.26,1C464.3,96.68,465.2,97.32,465.12,97.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M472.82,103.53a6.27,6.27,0,0,1-2-1.43c-1-.89-1.76-1.7-1.67-1.81s1,.52,2,1.42S472.92,103.43,472.82,103.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M477.68,109.13c-.12.08-.55-.29-1-.83s-.67-1.06-.56-1.15.54.28,1,.83S477.8,109,477.68,109.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M523.92,169.38a6.34,6.34,0,0,1-2.37-.82c-1.26-.58-2.23-1.16-2.16-1.29a6.3,6.3,0,0,1,2.38.82C523,168.67,524,169.24,523.92,169.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M533.36,172.66a6,6,0,0,1-2.46-.48,6.28,6.28,0,0,1-2.32-1,6.41,6.41,0,0,1,2.47.48A6.19,6.19,0,0,1,533.36,172.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M543.23,174.23a12,12,0,0,1-5-.54,6.27,6.27,0,0,1,2.51,0A6.5,6.5,0,0,1,543.23,174.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M553.21,173.92a5.91,5.91,0,0,1-2.47.45,6.2,6.2,0,0,1-2.52-.07,6.56,6.56,0,0,1,2.48-.45A6.43,6.43,0,0,1,553.21,173.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M563,172.08a6.14,6.14,0,0,1-2.37.85,6,6,0,0,1-2.51.24,6.72,6.72,0,0,1,2.4-.75A6.55,6.55,0,0,1,563,172.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M572.31,168.4c.07.13-.9.7-2.16,1.28a6.28,6.28,0,0,1-2.38.81,6.4,6.4,0,0,1,2.16-1.28A6.33,6.33,0,0,1,572.31,168.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M580.6,162.83c.09.11-.69.93-1.8,1.77a5.52,5.52,0,0,1-2.19,1.24c-.08-.12.78-.83,1.88-1.66A7.1,7.1,0,0,1,580.6,162.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M587.4,155.53a5.49,5.49,0,0,1-1.33,2.14c-.89,1.08-1.75,1.81-1.85,1.72s.58-1,1.45-2S587.28,155.44,587.4,155.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M592.08,146.73a5.29,5.29,0,0,1-.69,2.42,5.36,5.36,0,0,1-1.34,2.14,7.27,7.27,0,0,1,.86-2.35A7.42,7.42,0,0,1,592.08,146.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M593.93,137a5.28,5.28,0,0,1,.11,2.52,5.18,5.18,0,0,1-.62,2.45,7.78,7.78,0,0,1,.1-2.5A7.6,7.6,0,0,1,593.93,137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M592.49,127.09a5.45,5.45,0,0,1,.9,2.36,5.32,5.32,0,0,1,.21,2.51,7.44,7.44,0,0,1-.72-2.4A7.54,7.54,0,0,1,592.49,127.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M588.14,118.12c.11-.08.87.78,1.57,2a5.26,5.26,0,0,1,.94,2.34,7.72,7.72,0,0,1-1.39-2.07A7.58,7.58,0,0,1,588.14,118.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M581.2,111c.08-.12,1.08.44,2.13,1.35s1.75,1.82,1.65,1.92-1-.63-2-1.52S581.12,111.11,581.2,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M572.13,106.93a5,5,0,0,1,2.5.41,5,5,0,0,1,2.25,1.15,8.17,8.17,0,0,1-2.41-.66A8.55,8.55,0,0,1,572.13,106.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M562.22,107.09a5,5,0,0,1,2.42-.72,5.06,5.06,0,0,1,2.53.07,24.81,24.81,0,0,1-4.95.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M553.6,111.92c-.11-.09.58-1,1.71-1.87a4.71,4.71,0,0,1,2.26-1.15c.07.13-.87.74-2,1.57S553.71,112,553.6,111.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M549.64,120.89a4.56,4.56,0,0,1,.15-2.53,4.41,4.41,0,0,1,1.05-2.3,10.86,10.86,0,0,1-.55,2.43A9.63,9.63,0,0,1,549.64,120.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M551.59,130.59a4.93,4.93,0,0,1-1.21-2.22,4.73,4.73,0,0,1-.42-2.5,8.77,8.77,0,0,1,.91,2.33A8.62,8.62,0,0,1,551.59,130.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M558.13,138a5,5,0,0,1-2.13-1.36c-1.06-.93-1.71-1.87-1.6-2s.92.67,1.94,1.57S558.21,137.9,558.13,138Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M567.21,142.09a5.2,5.2,0,0,1-2.48-.46,5.31,5.31,0,0,1-2.25-1.15,7.5,7.5,0,0,1,2.41.66A7.82,7.82,0,0,1,567.21,142.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M577.13,143a9.23,9.23,0,0,1-5-.11,7.56,7.56,0,0,1,2.5-.12A7.28,7.28,0,0,1,577.13,143Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M586.93,141.22a5.49,5.49,0,0,1-2.34.95,5.42,5.42,0,0,1-2.5.28,17.23,17.23,0,0,1,4.84-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M596,137.07a6.27,6.27,0,0,1-2.09,1.4,6.07,6.07,0,0,1-2.33.93,6.51,6.51,0,0,1,2.09-1.4A6,6,0,0,1,596,137.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M604,131.11c.1.11-.69.91-1.76,1.79s-2,1.5-2.1,1.38.71-.91,1.77-1.79A6.25,6.25,0,0,1,604,131.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M610.83,123.8c.11.09-.53,1-1.43,2.07s-1.72,1.83-1.82,1.73.53-1,1.42-2.07S610.71,123.71,610.83,123.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M616.32,115.46a6.21,6.21,0,0,1-1.06,2.27c-.72,1.19-1.39,2.09-1.51,2a6.11,6.11,0,0,1,1.06-2.27A6.39,6.39,0,0,1,616.32,115.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M620.38,106.32a6.42,6.42,0,0,1-.67,2.42c-.5,1.3-1,2.29-1.18,2.23a7.16,7.16,0,0,1,.69-2.42A6.08,6.08,0,0,1,620.38,106.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M623.17,96.73a6.07,6.07,0,0,1-.37,2.48,6.26,6.26,0,0,1-.88,2.36,6.27,6.27,0,0,1,.37-2.49A6.25,6.25,0,0,1,623.17,96.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M624.92,86.88a6,6,0,0,1-.12,2.51,6.39,6.39,0,0,1-.63,2.44,6.08,6.08,0,0,1,.12-2.52A6.45,6.45,0,0,1,624.92,86.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M625.84,76.93a6.05,6.05,0,0,1,.08,2.51,5.91,5.91,0,0,1-.45,2.47,6.38,6.38,0,0,1-.07-2.51A6.31,6.31,0,0,1,625.84,76.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M626.16,66.94a6,6,0,0,1,.21,2.5,6,6,0,0,1-.31,2.5,6.55,6.55,0,0,1-.21-2.51A6.35,6.35,0,0,1,626.16,66.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M626.09,56.94a6.2,6.2,0,0,1,.3,2.49,6.08,6.08,0,0,1-.23,2.51,6.21,6.21,0,0,1-.29-2.5A6.32,6.32,0,0,1,626.09,56.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M625.94,50.79c.14,0,.27.25.28.56s-.1.58-.25.59-.27-.25-.27-.57S625.8,50.79,625.94,50.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 582.17,
    y: 24.68,
    width: 68.37,
    height: 46.09,
    transform: "translate(-1.55 66.82) rotate(-6.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M584.83,74.35v0l-5-45.85h0l68-7.38v0l5,45.84h0Zm-4.92-45.82,5,45.76,67.92-7.37-5-45.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M648.13,21.65a4,4,0,0,1-.57.68l-1.71,1.86c-1.55,1.65-3.72,4-6.39,6.78L618.17,53.24l-.17.18-.22-.13-.52-.33L591,36.15,583,31l-2.14-1.42a5.23,5.23,0,0,1-.73-.54,4.25,4.25,0,0,1,.8.43l2.2,1.33,8,5L617.6,52.43l.52.33-.39.05,21.42-22.14L645.68,24l1.79-1.79A5.13,5.13,0,0,1,648.13,21.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M585.13,74.85c-.14-.1,4.29-6.93,9.89-15.27s10.27-15,10.41-14.92-4.28,6.93-9.89,15.27S585.27,75,585.13,74.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M628,41.64c.13-.12,5.86,5.56,12.8,12.69s12.47,13,12.35,13.14-5.85-5.57-12.8-12.7S627.84,41.76,628,41.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Envelope_2",
    "data-name": "Envelope 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M337.45,160c.14,0,.35.51.47,1.2s.09,1.25-.05,1.27-.35-.51-.47-1.19S337.31,160.06,337.45,160Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M335.85,150.28a6.2,6.2,0,0,1,.65,2.4,6.11,6.11,0,0,1,.14,2.48,6,6,0,0,1-.65-2.4A6.11,6.11,0,0,1,335.85,150.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M334.42,140.5a6,6,0,0,1,.6,2.41,6.17,6.17,0,0,1,.09,2.48,6,6,0,0,1-.6-2.41A6.16,6.16,0,0,1,334.42,140.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M333.3,130.67a6.35,6.35,0,0,1,.52,2.43,5.94,5.94,0,0,1,0,2.49,6.12,6.12,0,0,1-.51-2.43A6.25,6.25,0,0,1,333.3,130.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M332.61,120.81a6,6,0,0,1,.4,2.45,6,6,0,0,1-.12,2.49,6.23,6.23,0,0,1-.4-2.46A6.11,6.11,0,0,1,332.61,120.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M332.51,110.92a6.26,6.26,0,0,1,.24,2.48,6.29,6.29,0,0,1-.27,2.47,5.91,5.91,0,0,1-.25-2.48A6,6,0,0,1,332.51,110.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M333.13,101.06a6.33,6.33,0,0,1,.05,2.49,6.19,6.19,0,0,1-.46,2.44,6,6,0,0,1-.06-2.49A6,6,0,0,1,333.13,101.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M334.61,91.29a5.84,5.84,0,0,1-.17,2.48,6,6,0,0,1-.69,2.39,6.15,6.15,0,0,1,.18-2.48A6.16,6.16,0,0,1,334.61,91.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M337.14,81.73a6.31,6.31,0,0,1-.46,2.45,6.14,6.14,0,0,1-.95,2.29,6,6,0,0,1,.45-2.44A6.06,6.06,0,0,1,337.14,81.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M340.83,72.57a6.15,6.15,0,0,1-.76,2.37,6,6,0,0,1-1.23,2.15,6.18,6.18,0,0,1,.76-2.36A6,6,0,0,1,340.83,72.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M345.65,63.94a6.18,6.18,0,0,1-1,2.26c-.7,1.16-1.37,2-1.5,2a6.18,6.18,0,0,1,1.06-2.25C344.86,64.75,345.53,63.87,345.65,63.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M351.58,56a6.12,6.12,0,0,1-1.34,2.09c-.86,1.06-1.64,1.84-1.76,1.76a6.16,6.16,0,0,1,1.35-2.09C350.69,56.73,351.48,55.94,351.58,56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M358.61,49.09c.09.11-.65.95-1.65,1.86s-1.9,1.58-2,1.48.64-.94,1.65-1.86S358.52,49,358.61,49.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M366.69,43.41c.07.13-.8.82-1.95,1.55a6.09,6.09,0,0,1-2.22,1.11c-.08-.12.79-.81,1.94-1.55A6.13,6.13,0,0,1,366.69,43.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375.69,39.36a6,6,0,0,1-2.21,1.14,6.05,6.05,0,0,1-2.39.66A6.08,6.08,0,0,1,373.3,40,6,6,0,0,1,375.69,39.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M382.91,37.58c0,.14-.5.36-1.17.49s-1.25.12-1.28,0,.5-.36,1.18-.49S382.89,37.44,382.91,37.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 330.3,
    y: -0.36,
    width: 50.11,
    height: 74.34,
    transform: "translate(192.86 354.97) rotate(-68.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M381,73.62h0L311.62,46.78v0L329.71,0h0l69.36,26.82v0ZM311.68,46.76,381,73.55,399,26.86,329.73.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M399.06,27.49a5.14,5.14,0,0,1-.88.38l-2.59.94L386,32.17,354.36,43.05l-.26.09L354,42.9l-.34-.58-17-29.38L331.51,4l-1.35-2.44a5.47,5.47,0,0,1-.44-.88,5.53,5.53,0,0,1,.55.81l1.47,2.38L337,12.7c4.44,7.55,10.5,17.87,17.19,29.28l.34.58-.4-.15,31.75-10.69,9.62-3.16,2.63-.82A6.41,6.41,0,0,1,399.06,27.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M311.65,47.42c-.09-.17,7.6-4.56,17.18-9.81s17.41-9.37,17.5-9.21-7.6,4.55-17.18,9.8S311.74,47.58,311.65,47.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M369.61,36.73c.18-.06,2.87,8.3,6,18.65s5.55,18.8,5.37,18.85-2.87-8.3-6-18.65S369.43,36.78,369.61,36.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Envelope_1",
    "data-name": "Envelope 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M308.33,171c.14,0,.21.58.16,1.27s-.22,1.24-.36,1.23-.22-.59-.16-1.27S308.19,171,308.33,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M308.58,160.81a6.3,6.3,0,0,1,.26,2.54,6.66,6.66,0,0,1-.27,2.55,12.83,12.83,0,0,1,0-5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M307.89,150.66a12.78,12.78,0,0,1,.47,5.07,6.42,6.42,0,0,1-.49-2.51A6.59,6.59,0,0,1,307.89,150.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306.2,140.63a12.61,12.61,0,0,1,1,5,6.5,6.5,0,0,1-.74-2.44A6.23,6.23,0,0,1,306.2,140.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M303.43,130.84a6.32,6.32,0,0,1,1,2.35,6.4,6.4,0,0,1,.51,2.51,12.48,12.48,0,0,1-1.52-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M299.54,121.45a6.09,6.09,0,0,1,1.28,2.21,6.48,6.48,0,0,1,.81,2.43,6.56,6.56,0,0,1-1.28-2.22A6.36,6.36,0,0,1,299.54,121.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M294.49,112.62c.12-.08.84.82,1.6,2a6.57,6.57,0,0,1,1.08,2.32c-.13.07-.81-.84-1.53-2A6.54,6.54,0,0,1,294.49,112.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M288.26,104.58c.11-.09.93.71,1.83,1.79a6.72,6.72,0,0,1,1.43,2.12c-.12.09-.93-.71-1.83-1.78A6.37,6.37,0,0,1,288.26,104.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M281,97.51c.09-.11,1,.57,2.06,1.51s1.81,1.79,1.71,1.9a6.7,6.7,0,0,1-2.06-1.51C281.63,98.47,280.86,97.62,281,97.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M272.71,91.56a6.68,6.68,0,0,1,2.26,1.2c1.17.78,2.06,1.51,2,1.62a6.28,6.28,0,0,1-2.26-1.19C273.52,92.42,272.63,91.69,272.71,91.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M263.65,87a6.23,6.23,0,0,1,2.42.82,6.54,6.54,0,0,1,2.2,1.31,6.79,6.79,0,0,1-2.42-.83A6.56,6.56,0,0,1,263.65,87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M254,83.88a6.37,6.37,0,0,1,2.53.41,6.7,6.7,0,0,1,2.39.91,6.3,6.3,0,0,1-2.53-.41A6.48,6.48,0,0,1,254,83.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M243.87,82.59a10.08,10.08,0,0,1,5.07.41,16.63,16.63,0,0,1-5.07-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M233.73,83.29a6.56,6.56,0,0,1,2.5-.56,6.39,6.39,0,0,1,2.56,0,6.77,6.77,0,0,1-2.5.56A6.66,6.66,0,0,1,233.73,83.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M223.91,85.9a6.41,6.41,0,0,1,2.35-1,6.6,6.6,0,0,1,2.5-.53,6.34,6.34,0,0,1-2.35,1A6.41,6.41,0,0,1,223.91,85.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.75,90.31a12.62,12.62,0,0,1,4.48-2.42,6.68,6.68,0,0,1-2.12,1.44A6.55,6.55,0,0,1,214.75,90.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M206.63,96.42c-.1-.11.7-.93,1.78-1.83s2-1.55,2.13-1.43-.72.93-1.79,1.83A6.66,6.66,0,0,1,206.63,96.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M200,104.09a5.73,5.73,0,0,1,1.29-2.21c.87-1.12,1.72-1.91,1.82-1.81s-.55,1-1.41,2.13S200.1,104.17,200,104.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M196.27,110.7c-.13-.06,0-.62.31-1.24s.65-1.08.78-1,0,.62-.31,1.24S196.4,110.75,196.27,110.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.73,169.71c0-.14.53-.33,1.21-.41s1.25,0,1.27.11-.51.32-1.21.41S132.74,169.85,132.73,169.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.83,168.59a7.91,7.91,0,0,1,2.48.37,8.22,8.22,0,0,1,2.42.65,5.13,5.13,0,0,1-2.53-.14A5.23,5.23,0,0,1,122.83,168.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.88,164.16a7.39,7.39,0,0,1,2.23,1.14,7.67,7.67,0,0,1,2.07,1.42,5.28,5.28,0,0,1-2.33-1C114.65,165,113.79,164.28,113.88,164.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.43,157.48c.11-.09.93.67,1.9,1.65s1.72,1.8,1.63,1.91-1-.55-2-1.55S106.32,157.57,106.43,157.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.55,149.38c.13-.07.84.8,1.59,2a6.42,6.42,0,0,1,1.16,2.24c-.12.09-.83-.79-1.59-1.95A6.26,6.26,0,0,1,100.55,149.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.23,140.35a6.17,6.17,0,0,1,1.22,2.2A6.37,6.37,0,0,1,98.2,145a12.09,12.09,0,0,1-2-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.36,130.75a6.26,6.26,0,0,1,.89,2.36,6.2,6.2,0,0,1,.38,2.49,6.37,6.37,0,0,1-.89-2.36A6.22,6.22,0,0,1,93.36,130.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.62,120.88a6.47,6.47,0,0,1,.63,2.44,6.3,6.3,0,0,1,.12,2.52,6.19,6.19,0,0,1-.63-2.44A6.08,6.08,0,0,1,91.62,120.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90.66,110.9a6.34,6.34,0,0,1,.46,2.48,6.34,6.34,0,0,1-.06,2.52,6.34,6.34,0,0,1-.46-2.48A6.12,6.12,0,0,1,90.66,110.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90.24,103.4c.15,0,.29.54.32,1.23s-.06,1.26-.2,1.26-.29-.54-.32-1.23S90.1,103.4,90.24,103.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 46.02,
    y: 44.7,
    width: 83.24,
    height: 56.11,
    transform: "translate(-3.33 4.21) rotate(-2.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.36,102.76v0L44.72,46.66h0l83.18-3.92v0l2.64,56.07h0Zm-2.59-56,2.64,56,83.1-3.92-2.64-56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128.19,43.43a5.48,5.48,0,0,1-.74.78l-2.22,2.14L117,54.12,89.44,79.59l-.23.21L89,79.62l-.6-.44L57.63,56.8l-9.26-6.86-2.49-1.89a5.48,5.48,0,0,1-.84-.7,6.86,6.86,0,0,1,.93.58l2.58,1.78L58,56.36,88.8,78.57l.61.44-.48,0,27.68-25.31L125,46.13l2.32-2A5.14,5.14,0,0,1,128.19,43.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.68,103.39c-.16-.12,5.73-8.1,13.16-17.81S74.43,68.09,74.59,68.22,68.87,76.32,61.44,86,47.85,103.52,47.68,103.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M102.2,66.22c.16-.14,6.7,7.2,14.6,16.38s14.19,16.74,14,16.88-6.69-7.2-14.6-16.39S102,66.35,102.2,66.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M193.56,241.85a2.28,2.28,0,0,0-1.73-2.53l-2.23.15-8-2.77a2.38,2.38,0,0,0-3,2.17c0,2.29-1,8.53-2.81,6.57l-.14-.13c-2.63-2.93-5.67-4.35-6.84-4.18a1.33,1.33,0,0,0-.58,2.36,1.41,1.41,0,0,0,.48.33c.08,0,.18.1.26.14a20.13,20.13,0,0,1,3.05,2.72,10.79,10.79,0,0,1,2,3c.53,1.23,1,2.32,1.28,3.25l.12,7.33-3.18,34.27s-21.1-22.16-20.61-22.38l1.21,34.49,12.78,10.58A16.08,16.08,0,0,0,192,304.61l-.74-44.31.52-5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M75.09,290.57,52,343.41,33.74,381.53l-13.57,4.56s-10.74,3.12-10.74,5.34,2.83,1.72,2.83,1.72c.52,3.32,5.12,1.43,8.34-.06S31,391.31,31,391.31a2.91,2.91,0,0,0-.2,4.66c1.14.8,3.12-.17,4.47-1.6s4.79-2.1,8.64-3.47,4.48-6.54,4.48-6.54l46.23-77.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.73,309.75l5.81,7.68,12.59-27.93s-12.22-14.91-16.69-21.17-7.75-7.27-7.75-7.27-8.12-2.42-12.17-2.33l-20.06,1.2-20.37,8.89a28.22,28.22,0,0,0-12.27,10.33L61.64,310,88.8,321.57l9.11,52.07c1.74,7.81,3.27,15.18,10.48,18.78L158.76,344l-5.9-9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103.57,300.2c.12.08-3,4.91-6.93,10.78s-7.25,10.57-7.36,10.49,3-4.91,6.93-10.78S103.45,300.12,103.57,300.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M145.8,349.64a9.38,9.38,0,0,1-1.34.8c-.87.48-2.15,1.16-3.74,2-3.19,1.65-7.61,3.86-12.56,6.19s-9.47,4.34-12.77,5.74c-1.65.7-3,1.26-3.92,1.62a9.33,9.33,0,0,1-1.47.53,7.86,7.86,0,0,1,1.39-.71l3.85-1.78c3.26-1.48,7.76-3.54,12.7-5.87s9.39-4.49,12.61-6l3.82-1.84A8.46,8.46,0,0,1,145.8,349.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M102,288.92a16.3,16.3,0,0,1-1.77-2.22,35.08,35.08,0,0,0-4.47-5.1A15.83,15.83,0,0,0,90,278.2c-1.65-.51-2.75-.5-2.75-.59a2,2,0,0,1,.77-.06,8.71,8.71,0,0,1,2.08.3,14.59,14.59,0,0,1,6,3.36,28.42,28.42,0,0,1,4.42,5.28A14.12,14.12,0,0,1,102,288.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M143.4,314.3a2,2,0,0,1,0,.55c0,.37,0,.9-.05,1.59a36.9,36.9,0,0,1-.81,5.77,41.39,41.39,0,0,1-23.27,29,39.22,39.22,0,0,1-5.46,2c-.66.2-1.19.3-1.54.39a3.08,3.08,0,0,1-.54.1,18.35,18.35,0,0,1,2-.69,44.44,44.44,0,0,0,5.36-2.17,42.32,42.32,0,0,0,23.08-28.77,46.64,46.64,0,0,0,1-5.71C143.31,315.06,143.36,314.3,143.4,314.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.32,341.7c-.09-.5,6.46-34.36,6.46-34.36L88.9,322.17"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.44,277.26a2.45,2.45,0,0,1,.07.58c0,.44.06,1,.11,1.67.07,1.53.18,3.61.31,6.16.25,5.26.6,12.4,1,20.3s.68,15.12.83,20.32c.08,2.6.13,4.7.15,6.16v1.68a2.17,2.17,0,0,1,0,.58,2.45,2.45,0,0,1-.07-.58c0-.44-.06-1-.11-1.67-.07-1.53-.18-3.61-.31-6.16-.25-5.26-.6-12.41-1-20.3s-.67-15.12-.83-20.32c-.08-2.6-.13-4.71-.15-6.16v-1.68A2.17,2.17,0,0,1,150.44,277.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.24,366.48c-1.61-1.35-1.25-4.08.18-5.62S114,358.65,116,358c9.57-3.1,19.19-7.49,25.5-15.32a15.45,15.45,0,0,1,2.83-3,3.89,3.89,0,0,1,3.93-.55c1.93,1,2,3.81,1.19,5.83a11.24,11.24,0,0,1-5.27,5.77"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "150.65 283.27 156.24 315.7 151.88 309.95 150.65 283.27"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.83,368.48l-9.45,32.41,40.27,12C235.56,408.94,217,395,217,395l6.91-20.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M205.09,389.58a1.72,1.72,0,0,0-1.7,1.54,1.66,1.66,0,0,0,1.51,1.7,1.82,1.82,0,0,0,1.79-1.64,1.71,1.71,0,0,0-1.77-1.59"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M194.38,400.89l1.08-3.23,38.21,12.68s1.56,1.32,1,2.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.73,395c-.06.19-1.07,0-2.23.33s-1.91,1-2.07.89.47-1.18,1.88-1.57S217.83,394.85,217.73,395Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M221.44,398c0,.2-1,.28-1.88.92s-1.37,1.45-1.56,1.39,0-1.22,1.16-2S221.49,397.83,221.44,398Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222.34,403.79c-.2,0-.18-1.08.65-2s1.87-1.09,1.9-.9-.7.6-1.37,1.37S222.54,403.83,222.34,403.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M218.79,390.17c-.14.15-1-.39-2.09-.64s-2.11-.17-2.16-.36,1-.66,2.32-.34S218.93,390,218.79,390.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M219.25,385.1a3.87,3.87,0,0,1-2-.61,9.46,9.46,0,0,1-1.92-1.27,11,11,0,0,1-1-1,2.54,2.54,0,0,1-.46-.66.88.88,0,0,1,.22-1.07,1.1,1.1,0,0,1,1-.19,2.91,2.91,0,0,1,.73.33,7.26,7.26,0,0,1,1.12.8,7.52,7.52,0,0,1,1.5,1.77c.68,1.15.78,2,.7,2s-.38-.71-1.12-1.71a8.26,8.26,0,0,0-1.5-1.54,8.37,8.37,0,0,0-1.05-.71c-.39-.23-.75-.34-.92-.19s-.07.09,0,.24a2,2,0,0,0,.34.48,11.34,11.34,0,0,0,.89.93,12.42,12.42,0,0,0,1.72,1.32A15.87,15.87,0,0,1,219.25,385.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M218.91,385.31a3.33,3.33,0,0,1,.05-2.11,6.51,6.51,0,0,1,.93-2.12,6.22,6.22,0,0,1,.88-1.08,1.75,1.75,0,0,1,1.59-.63,1,1,0,0,1,.67.81,3,3,0,0,1,0,.8,4.89,4.89,0,0,1-.4,1.36,5,5,0,0,1-1.48,1.83c-1.1.81-2,.8-2,.73s.76-.3,1.66-1.12a4.78,4.78,0,0,0,1.2-1.71,4,4,0,0,0,.31-1.17c.07-.45,0-.84-.16-.85a1.22,1.22,0,0,0-.91.46,7.17,7.17,0,0,0-.82.94,7.4,7.4,0,0,0-1,1.9C219,384.51,219,385.31,218.91,385.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M245.18,320.21c1,7.48-1.54,15.91-4.25,23l-17.66,41.52-19.55-3s-4.07,4.54-9.28,6.27c-2.33.78-10,2.29-16.31-2.25h0s-8.93,12.44-23,16.2-35.32,5.84-45.62-10.6l49-47.25c1,.25,42.23-27.55,64.5-33.88C223.05,310.18,243.3,306.46,245.18,320.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M202.27,381.53s.08-.06.26-.16l.8-.43c.71-.37,1.75-.9,3.07-1.63a52.46,52.46,0,0,0,4.68-2.89,24.33,24.33,0,0,0,5.29-4.9,17,17,0,0,0,3.43-7.94,26.38,26.38,0,0,0-.42-10A16.09,16.09,0,0,0,214,344.2a20.34,20.34,0,0,0-11-3.93,34.88,34.88,0,0,0-6,.05,45.46,45.46,0,0,0-5.81,1A69.19,69.19,0,0,0,180.54,345c-6.53,2.85-12.2,5.94-17.18,8.07a61.81,61.81,0,0,1-12.15,4.05c-.74.17-1.41.27-2,.36s-1.06.16-1.46.2l-.9.08-.31,0,.31-.07.89-.14c.39-.05.88-.12,1.45-.24s1.23-.23,2-.41a64.77,64.77,0,0,0,12.05-4.19c4.94-2.16,10.59-5.28,17.14-8.17a68,68,0,0,1,10.62-3.7,44.55,44.55,0,0,1,5.88-1,34,34,0,0,1,6.14-.06,20.82,20.82,0,0,1,11.32,4.05,14.27,14.27,0,0,1,3.67,4.47,20.3,20.3,0,0,1,1.87,5.22,27,27,0,0,1,.38,10.16,17.4,17.4,0,0,1-3.57,8.09,24.12,24.12,0,0,1-5.42,4.92,45.38,45.38,0,0,1-4.74,2.82c-1.34.71-2.4,1.22-3.12,1.56l-.82.37A1.23,1.23,0,0,1,202.27,381.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M214.53,327a58.66,58.66,0,0,1-4.1,6.69,58.47,58.47,0,0,1-4.53,6.39A119.77,119.77,0,0,1,214.53,327Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M200.43,378.23a33.3,33.3,0,0,1-3.55.91c-2.19.55-5.2,1.38-8.46,2.52s-6.13,2.37-8.18,3.31-3.31,1.57-3.35,1.5a3.56,3.56,0,0,1,.82-.55c.55-.33,1.36-.77,2.37-1.28a66.5,66.5,0,0,1,8.17-3.47,68.17,68.17,0,0,1,8.55-2.39c1.11-.22,2-.38,2.65-.47A3.16,3.16,0,0,1,200.43,378.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M222.92,382c-.09,0-.32-.89-1.15-2.11a8.45,8.45,0,0,0-10.06-3.26c-1.39.5-2.12,1.1-2.18,1s.14-.2.48-.47a7.08,7.08,0,0,1,1.56-.9,8.33,8.33,0,0,1,10.51,3.41,6.89,6.89,0,0,1,.73,1.65C222.93,381.73,223,382,222.92,382Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.34,366.48a2.69,2.69,0,0,1,.26.93,15,15,0,0,1,.22,2.63,16.15,16.15,0,0,1-2.3,8.35,12.77,12.77,0,0,1-6.7,5.45,9.53,9.53,0,0,1-2.6.49,2.87,2.87,0,0,1-1,0,18.68,18.68,0,0,0,3.45-.8,13.14,13.14,0,0,0,6.38-5.37,17.11,17.11,0,0,0,2.38-8.09C138.55,367.84,138.25,366.49,138.34,366.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.29,388.91c-.11.09-.63-.37-1.12-1.05s-.75-1.32-.62-1.39.57.43,1,1.09S116.4,388.82,116.29,388.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.41,393.25c-.1.11-.66-.27-1.26-.85s-1-1.13-.9-1.23.67.29,1.26.86S120.5,393.15,120.41,393.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.26,396.76c-.07.13-.7-.14-1.4-.59s-1.2-.92-1.12-1,.72.15,1.4.6S125.33,396.64,125.26,396.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130.76,399.13c0,.14-.71,0-1.5-.26s-1.38-.63-1.32-.76.73,0,1.49.27S130.8,399,130.76,399.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.67,400.06c0,.14-.68.2-1.52.12s-1.49-.25-1.47-.39.71-.2,1.52-.13S136.67,399.91,136.67,400.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M142.65,399.73c0,.15-.64.31-1.48.36a5.77,5.77,0,0,1-1.12,0h0c-.25,0-.4-.06-.41-.13s.13-.14.37-.21h0a5.43,5.43,0,0,1,1.1-.17C142,399.52,142.63,399.59,142.65,399.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M148.54,398.67c0,.14-.59.39-1.41.57s-1.49.2-1.51.05.6-.39,1.41-.56S148.51,398.53,148.54,398.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.28,396.92c.05.14-.55.46-1.34.72s-1.47.37-1.51.23.56-.46,1.34-.72S154.23,396.79,154.28,396.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.79,394.58c.07.13-.5.51-1.25.86s-1.42.52-1.48.38.51-.51,1.26-.86S159.73,394.45,159.79,394.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M165.05,391.7c.07.12-.45.56-1.17,1s-1.36.65-1.42.52.45-.56,1.16-1S165,391.57,165.05,391.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170,388.32c.09.11-.39.6-1.07,1.08s-1.29.79-1.37.67.4-.61,1.07-1.09S169.91,388.2,170,388.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174.62,384.5c.1.11-.34.63-1,1.18s-1.22.89-1.31.78.34-.64,1-1.18S174.52,384.39,174.62,384.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M179,380.38c.1.11-.31.66-.91,1.22s-1.18.94-1.27.84.3-.65.91-1.22S178.89,380.27,179,380.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183.72,376.69c.08.13-.39.61-1.06,1.1s-1.28.78-1.37.67.39-.6,1.06-1.09S183.64,376.57,183.72,376.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M189,373.8c.06.13-.5.53-1.23.89s-1.39.56-1.46.44.48-.53,1.23-.9S188.92,373.66,189,373.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.7,372c0,.15-.6.42-1.39.62s-1.48.25-1.52.11.58-.41,1.39-.61S194.68,371.87,194.7,372Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M200.68,371.71c0,.15-.69.19-1.51.18s-1.48-.09-1.49-.23.66-.31,1.5-.29S200.69,371.57,200.68,371.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.46,373.23c-.07.12-.71-.07-1.47-.34s-1.39-.53-1.36-.68.73-.09,1.53.19S206.52,373.1,206.46,373.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205.19,377.58c-.09-.12.36-.61.89-1.21s1-1.1,1.09-1-.12.74-.7,1.38S205.28,377.69,205.19,377.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M199.9,380.33c-.05-.14.53-.5,1.28-.81s1.42-.46,1.49-.34-.51.5-1.29.82S199.94,380.46,199.9,380.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.18,382.16c-.05-.13.55-.46,1.34-.72s1.46-.37,1.51-.23-.56.46-1.34.72S194.23,382.3,194.18,382.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.58,384.3c-.06-.13.52-.49,1.3-.79s1.44-.44,1.49-.31-.53.49-1.3.79S188.63,384.43,188.58,384.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183.05,386.64c-.06-.13.51-.51,1.27-.84s1.43-.48,1.48-.35-.51.5-1.27.83S183.1,386.77,183.05,386.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171.87,215.16s6.54-2,15.23-11.66,12.19-22,13.34-22,6-2.72,17,17.26,7.66,25.06,5.77,25.17-15-2.53-23-1-18,6.46-18,6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M158.58,227.49l2.59,4.14,1.16,1.86a5.65,5.65,0,0,0,7.53,1.95l13.88-6L174,211.08l-13.68,8.65A5.65,5.65,0,0,0,158.58,227.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M167.31,233.78l5.21,8.57,2.22-.8,15.73,11,3.54-8.42s-9-3.13-10.9-6.13,0-3.86,0-3.86l-4.47-4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.73,199.2c5.89,10.83,8.74,20.66,6.36,22s-9.08-6.44-15-17.27-8.74-20.66-6.36-21.95S210.83,188.37,216.73,199.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "157.82 233.81 161.6 232.31 158.87 227.94 156.1 229.96 157.82 233.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "180.14 231.22 170.25 238.62 168.77 236.18 180.14 231.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "158.87 227.94 161.6 232.31 160.82 232.62 158.54 228.19 158.87 227.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.61,228.79a21.1,21.1,0,0,0,4.18-2,21.53,21.53,0,0,0,3.94-2.43,22.12,22.12,0,0,0-4.18,2A22.19,22.19,0,0,0,161.61,228.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.22,226.18a18.65,18.65,0,0,0,3.77-1.94,17.89,17.89,0,0,0,3.53-2.36,18.24,18.24,0,0,0-3.78,1.94A18,18,0,0,0,160.22,226.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M163.32,231.52c0,.07.47-.07,1.19-.35l1.25-.52c.46-.21.94-.5,1.45-.77a16.5,16.5,0,0,0,3.52-2.33,19.68,19.68,0,0,0-3.76,1.89c-.51.28-1,.57-1.42.8s-.85.43-1.19.61C163.7,231.2,163.29,231.46,163.32,231.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.22,197.48s5.52-4,9.26,3.56-2.24,9.31-2.24,9.31A52.3,52.3,0,0,1,206.22,197.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M199.39,188.63a7.34,7.34,0,0,0,.33,1.47c.26,1,.62,2.31,1.12,4,.3.82.64,1.72,1,2.68.18.48.37,1,.56,1.49.1.25.19.51.29.77s.24.52.36.78l1.56,3.27.41.86c.13.29.31.56.47.84q.49.84,1,1.71c.34.57.67,1.14,1,1.7.17.28.32.57.5.83l.55.78,2.07,3c.17.23.32.47.49.69l.54.64c.34.43.68.84,1,1.23l1.83,2.2c1.21,1.25,2.21,2.24,2.9,2.93a8,8,0,0,0,1.12,1,11,11,0,0,0-1-1.16l-2.78-3L213,215.07l-1-1.24-.52-.64c-.17-.22-.32-.46-.48-.7-.65-.94-1.33-1.94-2-3l-.53-.78c-.19-.26-.33-.55-.5-.83l-1-1.69-1-1.7c-.15-.28-.33-.54-.47-.83s-.27-.57-.41-.85l-1.57-3.24c-.12-.26-.26-.51-.36-.76s-.21-.52-.31-.77c-.2-.51-.39-1-.58-1.47L201.17,194c-.53-1.64-.95-3-1.26-3.92A10.32,10.32,0,0,0,199.39,188.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M184.52,234.13a1.69,1.69,0,0,1,1.17,2.05c-.43,1.7-1.13,4.37-1.69,6a4.59,4.59,0,0,1-.75,1.48,1.4,1.4,0,0,1-2.55-.72,4.53,4.53,0,0,1,.15-1.75c.35-1.58,1-4,1.56-5.9a1.69,1.69,0,0,1,2.11-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M187.23,236.89a1.69,1.69,0,0,1,1.17,2.05c-.43,1.7-1.13,4.37-1.7,6a4.14,4.14,0,0,1-.75,1.48,1.39,1.39,0,0,1-2.54-.72,4.66,4.66,0,0,1,.14-1.74c.36-1.59,1-4,1.56-5.91a1.7,1.7,0,0,1,2.12-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M189.84,238.55a1.46,1.46,0,0,1,1,1.77c-.37,1.47-1,3.79-1.47,5.2a3.69,3.69,0,0,1-.65,1.28,1.34,1.34,0,0,1-1.29.49,1.35,1.35,0,0,1-.91-1.11,3.86,3.86,0,0,1,.12-1.51c.31-1.37.87-3.44,1.35-5.12a1.48,1.48,0,0,1,1.83-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M192.81,238.88a1.48,1.48,0,0,1,1,1.79c-.37,1.48-1,3.8-1.48,5.22a3.83,3.83,0,0,1-.65,1.29,1.21,1.21,0,0,1-2.21-.63,3.92,3.92,0,0,1,.12-1.52c.31-1.38.87-3.45,1.36-5.14a1.48,1.48,0,0,1,1.84-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M183.58,243.69a10.47,10.47,0,0,1,.73-3.2,10.58,10.58,0,0,1,1.24-3,10.27,10.27,0,0,1-.74,3.2A10.58,10.58,0,0,1,183.58,243.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M189.21,246a41,41,0,0,1,1.87-6.28,13.93,13.93,0,0,1-1.87,6.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M186.42,245.6a13.7,13.7,0,0,1,.81-3.18,13.85,13.85,0,0,1,1.06-3.11,14,14,0,0,1-1.87,6.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.23,161c.11.09-4,5.66-9.16,12.44s-9.46,12.21-9.57,12.12,4-5.65,9.15-12.44S237.11,161,237.23,161Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M264.06,176.9c.06.13-8.56,4.26-19.26,9.23s-19.41,8.88-19.47,8.75,8.56-4.26,19.25-9.22S264,176.77,264.06,176.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M260.06,209.93c0,.14-6.16-.34-13.72-1.07s-13.69-1.43-13.68-1.58,6.16.34,13.73,1.07S260.08,209.78,260.06,209.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M102.4,228.45l6.79,38.6a12.7,12.7,0,0,0,14.3,10.28h0a12.56,12.56,0,0,0,10.8-14.44l-1.1-6.65s9.5-2.57,8.51-12.11c-.48-4.6-2.24-14-3.94-22.46A18.2,18.2,0,0,0,117,207.44h0A17.76,17.76,0,0,0,102.4,228.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M133.21,256.26a23,23,0,0,1-13-2.1s3.78,6.52,13.33,4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M135.69,228.11a1.37,1.37,0,0,1-1.17,1.52,1.33,1.33,0,0,1-1.56-1.07,1.37,1.37,0,0,1,1.17-1.52A1.32,1.32,0,0,1,135.69,228.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136,225.8c-.15.19-1.29-.45-2.77-.28s-2.49,1-2.67.87.05-.41.48-.81a3.87,3.87,0,0,1,2.11-.91,3.75,3.75,0,0,1,2.24.44C135.89,225.41,136.09,225.71,136,225.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.72,229.79a1.37,1.37,0,0,1-1.17,1.52,1.33,1.33,0,0,1-1.57-1.06,1.37,1.37,0,0,1,1.17-1.53A1.34,1.34,0,0,1,121.72,229.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.65,227.72c-.15.2-1.28-.44-2.77-.27s-2.49,1-2.67.86.05-.41.49-.8a3.8,3.8,0,0,1,2.11-.91A3.67,3.67,0,0,1,121,227C121.54,227.33,121.73,227.63,121.65,227.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128.31,238.85a9.38,9.38,0,0,1,2.37-.7c.37-.09.72-.2.76-.46a1.93,1.93,0,0,0-.39-1.08l-1.45-2.72c-2-3.88-3.55-7.08-3.39-7.16s1.94,3,4,6.87l1.4,2.74a2.13,2.13,0,0,1,.37,1.45,1,1,0,0,1-.56.62,3.06,3.06,0,0,1-.63.16A10.06,10.06,0,0,1,128.31,238.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124.06,240.35c.24,0,.43,1.55,1.94,2.52s3.21.61,3.24.83-.34.35-1.07.45a4.1,4.1,0,0,1-2.7-.6,3.46,3.46,0,0,1-1.52-2.12C123.81,240.77,124,240.36,124.06,240.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.37,222.82c-.1.42-1.61.4-3.33.8s-3.07,1-3.34.7c-.13-.16.07-.56.6-1a6,6,0,0,1,5.08-1.14C121.05,222.35,121.41,222.63,121.37,222.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M135.19,222.5c-.22.37-1.29.14-2.52.26s-2.25.48-2.53.16c-.12-.16,0-.51.42-.88a3.73,3.73,0,0,1,4.07-.33C135.1,222,135.28,222.33,135.19,222.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.81,205.36a3.38,3.38,0,0,0-4.39.28,3,3,0,0,0-.85-4,5.12,5.12,0,0,0-4.37-.63,15.08,15.08,0,0,0-4.09,2,1.53,1.53,0,0,0-.67-1.55,3.59,3.59,0,0,0-1.72-.54,13,13,0,0,0-7.21,1.62,45,45,0,0,0-6.67,4.53h0a31.36,31.36,0,0,0-6.1,6.52l-.08.07c-1.41,1.26-2.6,5.05-2.39,6.92.79,6.86,3.07,10.84,4.35,17.34a2.25,2.25,0,0,0,.49,1.2c.79.83,2.21.13,3-.73a12.28,12.28,0,0,0,2.54-7.73c.09-2.76-.31-5.51-.24-8.27v-.2a15.8,15.8,0,0,1,.2-2.11c.12-.44,1.29-4.38,5.08-5,4-.68,12,3.22,15.88,2.6s4.14-3.4,4.14-3.4L137,219a14.2,14.2,0,0,0,.37-5.87,6.67,6.67,0,0,0,1.95-3.43A4.42,4.42,0,0,0,137.81,205.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M106.17,232.55c-.17-.05-6.87-1.18-5.9,5.3s7.39,4.19,7.37,4S106.17,232.55,106.17,232.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M105.26,239.69s-.1.1-.28.21a1.19,1.19,0,0,1-.86.14,2.84,2.84,0,0,1-1.69-2.31,3.86,3.86,0,0,1,.08-1.67,1.31,1.31,0,0,1,.74-1,.6.6,0,0,1,.72.21c.11.17.09.3.13.31s.12-.13,0-.39a.78.78,0,0,0-.32-.37.92.92,0,0,0-.66-.07,1.62,1.62,0,0,0-1.05,1.18,3.83,3.83,0,0,0-.12,1.86,3,3,0,0,0,2.09,2.56,1.25,1.25,0,0,0,1-.32C105.27,239.85,105.29,239.7,105.26,239.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.38,279.54a1.2,1.2,0,0,1,.57-.09,2.27,2.27,0,0,1,1.48.73,3.25,3.25,0,0,1,.86,2.46,14.27,14.27,0,0,1-.76,3.37,4.58,4.58,0,0,0,.23,3.85c.71,1.24,2.16,2.19,2.75,3.91a4.63,4.63,0,0,1-1.45,5,4.75,4.75,0,0,1-2.7,1.05,10.22,10.22,0,0,1-2.89-.47,5.2,5.2,0,0,0-2.69-.17,3.9,3.9,0,0,0-2,1.62,14.84,14.84,0,0,1-1.7,2.13,3.4,3.4,0,0,1-2.53.93,5.07,5.07,0,0,1-4-2.65,9.82,9.82,0,0,1-1-4.08c-.07-1.28,0-2.43-.05-3.43a17.18,17.18,0,0,0-.22-2.55,13.07,13.07,0,0,0-.61-2.1,2,2,0,0,1,.29.49,7.37,7.37,0,0,1,.51,1.57,14.14,14.14,0,0,1,.32,2.58c0,1,0,2.16.13,3.41a9.38,9.38,0,0,0,1,3.9,4.61,4.61,0,0,0,3.63,2.38,2.89,2.89,0,0,0,2.17-.82,13.43,13.43,0,0,0,1.63-2.07,4.41,4.41,0,0,1,2.26-1.81,5.7,5.7,0,0,1,3,.16,9.71,9.71,0,0,0,2.74.46,4.14,4.14,0,0,0,3.73-5.41c-.49-1.53-1.9-2.5-2.68-3.84a4.08,4.08,0,0,1-.57-2.17,7.8,7.8,0,0,1,.37-2,15.08,15.08,0,0,0,.82-3.28,3,3,0,0,0-.72-2.31,2.27,2.27,0,0,0-1.34-.77C91.58,279.51,91.38,279.57,91.38,279.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.13,349.53s.07.24.3.62A2.6,2.6,0,0,0,96,351.22a3.09,3.09,0,0,0,2.86-.6,6,6,0,0,0,1.91-3.49c.32-1.49.26-3.19.55-5a8.14,8.14,0,0,1,.92-2.74,4.54,4.54,0,0,1,2.3-2.05,6.48,6.48,0,0,1,3.21-.3c1.09.12,2.16.36,3.24.5a7.68,7.68,0,0,0,3.27-.15,7.37,7.37,0,0,0,2.92-1.63A6.3,6.3,0,0,0,119,333a5.3,5.3,0,0,0-.06-3.18,5.49,5.49,0,0,0-4.35-3.87c-2-.22-3.8.75-5.69.78a5.4,5.4,0,0,1-2.64-.59,13.14,13.14,0,0,1-2.07-1.33,12.65,12.65,0,0,0-3.5-2.14,3.64,3.64,0,0,0-3,.19,2.73,2.73,0,0,0-1.28,1.4c-.15.42-.13.67-.16.66a1.52,1.52,0,0,1,.06-.69,2.71,2.71,0,0,1,1.28-1.54,3.68,3.68,0,0,1,1.4-.48,4.25,4.25,0,0,1,1.74.18,12.77,12.77,0,0,1,3.64,2.12,7,7,0,0,0,4.47,1.79,13.84,13.84,0,0,0,2.73-.5,8.65,8.65,0,0,1,3-.33,6,6,0,0,1,4.77,4.19,5.69,5.69,0,0,1,.07,3.49,6.85,6.85,0,0,1-1.94,3,8,8,0,0,1-3.13,1.74,8.34,8.34,0,0,1-3.47.16c-1.12-.15-2.19-.39-3.23-.51a6.05,6.05,0,0,0-3,.24,4.12,4.12,0,0,0-2.08,1.84,7.94,7.94,0,0,0-.9,2.58c-.29,1.76-.26,3.49-.61,5A6.23,6.23,0,0,1,99,350.85a3.32,3.32,0,0,1-3.09.57,2.64,2.64,0,0,1-1.59-1.22A1.49,1.49,0,0,1,94.13,349.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M128.1,288.94a3.5,3.5,0,0,1,.69-.93,5.34,5.34,0,0,1,3-1.51,5.16,5.16,0,0,1,4.78,1.91,5.49,5.49,0,0,1,1.21,3.09,8.2,8.2,0,0,0,.76,3.48,2.75,2.75,0,0,0,1.46,1.09,7.45,7.45,0,0,0,2,.3c.7,0,1.42,0,2.17.11a4.15,4.15,0,0,1,2.19.77,2.73,2.73,0,0,1,.76,1,2.66,2.66,0,0,1,.2,1.25,4.17,4.17,0,0,1-1,2.26,6.39,6.39,0,0,1-2,1.57c-.75.38-1.54.69-2.31,1a7.92,7.92,0,0,0-2.13,1.32,4.14,4.14,0,0,0-1.25,2.12c-.41,1.69,0,3.5-.12,5.41a7,7,0,0,1-.76,2.8,3.31,3.31,0,0,1-2.38,1.78,3.65,3.65,0,0,1-2.87-.94,8.91,8.91,0,0,1-1.91-2.33,25,25,0,0,0-1.54-2.46,4.49,4.49,0,0,0-2.13-1.65,3.82,3.82,0,0,0-2.62.16,17.35,17.35,0,0,0-2.44,1.3,13.93,13.93,0,0,1-2.48,1.3,7.46,7.46,0,0,1-2.75.45,8.58,8.58,0,0,1-5-1.75,7.16,7.16,0,0,1-2.74-4.23,4.9,4.9,0,0,1,1.19-4.57A4.58,4.58,0,0,1,112,302a17.05,17.05,0,0,1,2.15-.38,6.92,6.92,0,0,0,3.68-1.24,7.38,7.38,0,0,0,2-3c.43-1.07.71-2.13,1.08-3.1a8.94,8.94,0,0,1,1.35-2.55,10.84,10.84,0,0,1,1.74-1.68,6.16,6.16,0,0,1,3-1.45,1.31,1.31,0,0,1,1.11.31,1.82,1.82,0,0,0-1.1-.21,6.27,6.27,0,0,0-2.87,1.51,11.48,11.48,0,0,0-1.68,1.67,9.31,9.31,0,0,0-1.27,2.5c-.35,1-.62,2-1,3.12a7.69,7.69,0,0,1-2,3.13,7.31,7.31,0,0,1-3.87,1.36c-1.37.2-2.9.35-4,1.36a4.43,4.43,0,0,0-1,4.15,6.66,6.66,0,0,0,2.58,3.94,8.18,8.18,0,0,0,4.73,1.65,7.25,7.25,0,0,0,2.56-.43,13.79,13.79,0,0,0,2.4-1.26,16.69,16.69,0,0,1,2.51-1.35,4.38,4.38,0,0,1,3-.18,5.06,5.06,0,0,1,2.38,1.84,23.47,23.47,0,0,1,1.58,2.51,8.67,8.67,0,0,0,1.79,2.19,3.16,3.16,0,0,0,2.46.83,2.8,2.8,0,0,0,2-1.52,6.57,6.57,0,0,0,.7-2.59c.1-1.79-.3-3.66.15-5.49a4.68,4.68,0,0,1,1.4-2.37,8.58,8.58,0,0,1,2.26-1.38c.79-.36,1.57-.66,2.3-1a5.87,5.87,0,0,0,1.85-1.45,3.76,3.76,0,0,0,.95-2,2,2,0,0,0-.8-1.85,3.6,3.6,0,0,0-2-.69c-.71-.08-1.43-.08-2.14-.13a7.74,7.74,0,0,1-2.09-.34,3.12,3.12,0,0,1-1.64-1.25,8.34,8.34,0,0,1-.78-3.64,5.24,5.24,0,0,0-1.1-3,5,5,0,0,0-4.53-1.89,5.44,5.44,0,0,0-2.91,1.38A9.74,9.74,0,0,0,128.1,288.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M111.27,272.06a3.55,3.55,0,0,1-2.08,1,6.92,6.92,0,0,1-2.54,0,4.44,4.44,0,0,1-2.73-1.57,5.85,5.85,0,0,1-1-3,8,8,0,0,1,.17-2.52,3.39,3.39,0,0,1,1.07-2,8.77,8.77,0,0,0-.7,2.12,8.55,8.55,0,0,0-.07,2.41,5.83,5.83,0,0,0,.93,2.71,4.09,4.09,0,0,0,2.41,1.41,7,7,0,0,0,2.38.09A10.22,10.22,0,0,0,111.27,272.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154.32,269.51s0,.1-.07.27a2.76,2.76,0,0,1-.39.72,4.55,4.55,0,0,1-4.6,1.7,5.6,5.6,0,0,1-2.12-1.13,7,7,0,0,0-2.11-1.29,1.91,1.91,0,0,0-2.13.84,18,18,0,0,0-1.23,2.44,5,5,0,0,1-1.77,2,4.72,4.72,0,0,1-6.67-1.44,2,2,0,0,1-.41-1s.17.36.57.91a4.91,4.91,0,0,0,2.26,1.68,4.44,4.44,0,0,0,4-.53,4.58,4.58,0,0,0,1.57-1.84,19,19,0,0,1,1.26-2.51,2.78,2.78,0,0,1,1.19-1,2.41,2.41,0,0,1,1.5,0,7.17,7.17,0,0,1,2.27,1.4,5.32,5.32,0,0,0,1.93,1.09,4.2,4.2,0,0,0,1.93,0,4.45,4.45,0,0,0,2.41-1.43C154.14,269.85,154.28,269.48,154.32,269.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M161.45,308.77a5.7,5.7,0,0,1-1.11-.73,22.52,22.52,0,0,1-2.73-2.37,13.12,13.12,0,0,1-1.59-2,6.55,6.55,0,0,1-1-2.75,5.39,5.39,0,0,1,.51-3.21,4.16,4.16,0,0,1,1.13-1.35,12.16,12.16,0,0,1,1.47-.94,5.81,5.81,0,0,0,1.33-1,3.15,3.15,0,0,0,.77-1.32,7.69,7.69,0,0,0,.1-3,15.1,15.1,0,0,1-.21-2.88,3.52,3.52,0,0,1,.93-2.39,5.31,5.31,0,0,1,3.37-1.35c.91,0,1.27.46,1.24.46a2.25,2.25,0,0,0-1.23-.26,5.32,5.32,0,0,0-3.12,1.41,3.15,3.15,0,0,0-.76,2.15,16.7,16.7,0,0,0,.25,2.8,7.87,7.87,0,0,1-.08,3.23,3.61,3.61,0,0,1-.89,1.53,6.11,6.11,0,0,1-1.44,1.05A5.39,5.39,0,0,0,156,298a5,5,0,0,0-.49,2.91,8,8,0,0,0,2.38,4.52C159.94,307.62,161.51,308.69,161.45,308.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M140.54,328.61a1.38,1.38,0,0,1,.46,0,12.8,12.8,0,0,1,1.34.07,13.12,13.12,0,0,1,4.74,1.38,8.65,8.65,0,0,1,4.48,5.68,6,6,0,0,1-.62,4.33,5.89,5.89,0,0,1-3.76,2.81,5.35,5.35,0,0,1-2.43-.13,3.3,3.3,0,0,0-2.08,0,4,4,0,0,0-1.62,1.24,12.1,12.1,0,0,0-1.11,1.73,6.73,6.73,0,0,1-2.61,3,4.93,4.93,0,0,1-3.43.41,4.32,4.32,0,0,1-2.39-1.56,4.84,4.84,0,0,1-.92-1.94,4.11,4.11,0,0,1-.07-1.35,1.43,1.43,0,0,1,.1-.46,7.2,7.2,0,0,0,.17,1.76,4.71,4.71,0,0,0,1,1.8,4,4,0,0,0,2.24,1.39,4.6,4.6,0,0,0,3.15-.43,6.38,6.38,0,0,0,2.39-2.83,6.45,6.45,0,0,1,3-3.22,3.8,3.8,0,0,1,2.38,0,4.74,4.74,0,0,0,2.21.13,5.38,5.38,0,0,0,3.42-2.56,5.57,5.57,0,0,0,.59-4,8.31,8.31,0,0,0-4.19-5.45,13.93,13.93,0,0,0-4.58-1.51C141.18,328.67,140.53,328.65,140.54,328.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.81,361.64a6.7,6.7,0,0,0-.93-2.06,5,5,0,0,0-1.87-1.51,3.93,3.93,0,0,0-5.16,1.38,5,5,0,0,0-.86,2.24,6.9,6.9,0,0,0,.22,2.26s-.17-.17-.33-.55a4.05,4.05,0,0,1-.26-1.74,5.18,5.18,0,0,1,.83-2.48,4.33,4.33,0,0,1,5.77-1.55,5.18,5.18,0,0,1,2,1.73,4,4,0,0,1,.64,1.64C121.87,361.41,121.84,361.64,121.81,361.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M125,376.19s-.09-.47-.45-1.23a5.25,5.25,0,0,0-2.4-2.46,4.93,4.93,0,0,0-4.87.37,7.65,7.65,0,0,0-2,2.28,7.23,7.23,0,0,1-1.14,1.3,2.73,2.73,0,0,1-1.75.64,4.35,4.35,0,0,1-3-1.8,9.77,9.77,0,0,0-2.12-2.21,3.74,3.74,0,0,0-2.59-.47,5.14,5.14,0,0,0-2.19.91,8.8,8.8,0,0,0-2.3,2.65,9.1,9.1,0,0,1-.69,1.13,5.19,5.19,0,0,1,.51-1.23,8.46,8.46,0,0,1,2.26-2.84,5.53,5.53,0,0,1,2.34-1.05,4.15,4.15,0,0,1,2.92.49,10.19,10.19,0,0,1,2.25,2.29,3.88,3.88,0,0,0,2.62,1.61,3.21,3.21,0,0,0,2.46-1.72,8.12,8.12,0,0,1,2.17-2.38,5.18,5.18,0,0,1,7.73,2.41,4,4,0,0,1,.25,1C125,376.07,125,376.19,125,376.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M132.69,339.91a11.45,11.45,0,0,0-2.88-1.27,9.08,9.08,0,0,0-3.36-.18,8,8,0,0,0-3.8,1.48,6.9,6.9,0,0,0-2.4,3.25,7.16,7.16,0,0,0-.36,3.31,9.43,9.43,0,0,0,1.06,2.95,2.33,2.33,0,0,1-.56-.67,6.07,6.07,0,0,1-.87-2.22,7.29,7.29,0,0,1,2.82-7,8.27,8.27,0,0,1,4-1.54,8.69,8.69,0,0,1,3.52.31,6.75,6.75,0,0,1,2.14,1C132.5,339.65,132.71,339.89,132.69,339.91Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotEmail);
export default __webpack_public_path__ + "static/media/forgotEmail.e370728de7d34413e139c0a0cd4b6e52.svg";
export { ForwardRef as ReactComponent };